export default "__VITE_ASSET__CpFwu_rJ__"